import { Menu, X, LogOut, User } from 'lucide-react';
import { useAuth } from '../helpers/useAuth';
import { useNavigate } from 'react-router-dom';
import ghruLogo from '../assets/ghraisoni-whitelogo.png';  
const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const { isLoggedIn, logout, user } = useAuth();
  const navigate = useNavigate();

  if (!isLoggedIn) return null;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
 <header
  className="relative flex items-center justify-between px-6 py-3 shadow-md z-10"
  style={{
    background: 'linear-gradient(to right, #3b1a6b, #5B2D8E)',
    color: '#fff',
  }}
>
  {/* Left: Toggle */}
  <div className="flex items-center z-10">
    <button
      onClick={() => setSidebarOpen(prev => !prev)}
      className="p-1 rounded-md transition-colors"
      style={{ color: 'rgba(255,255,255,0.8)' }}
      aria-label="Toggle Sidebar"
    >
      {sidebarOpen ? <X size={22} /> : <Menu size={22} />}
    </button>
  </div>

  {/* Center: Logo + Title */}
  <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-3">
    <img
      src={ghruLogo}
      alt="GH Raisoni University"
      className="h-10 w-auto object-contain"
    />

    <div className="hidden sm:block text-center">
      <h1
        className="text-sm font-bold leading-tight tracking-wide"
        style={{ color: '#f5d87a' }}
      >
        GH RAISONI ADMISSIONS CRM
      </h1>

      <p
        className="text-xs"
        style={{ color: 'rgba(255,255,255,0.6)' }}
      >
        G H Raisoni University, Saikheda
      </p>
    </div>
  </div>

  {/* Right: User info + Logout */}
  <div className="flex items-center gap-4 z-10">
    {user && (
      <div
        className="hidden sm:flex items-center gap-2 text-sm"
        style={{ color: 'rgba(255,255,255,0.8)' }}
      >
        <User size={16} />
        <span>{user.name || user.email || 'Admin'}</span>
      </div>
    )}

    <button
      onClick={handleLogout}
      className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all"
      style={{
        backgroundColor: 'rgba(245, 216, 122, 0.15)',
        color: '#f5d87a',
        border: '1px solid rgba(245, 216, 122, 0.3)',
      }}
      onMouseEnter={e =>
        (e.currentTarget.style.backgroundColor =
          'rgba(245, 216, 122, 0.28)')
      }
      onMouseLeave={e =>
        (e.currentTarget.style.backgroundColor =
          'rgba(245, 216, 122, 0.15)')
      }
    >
      <LogOut size={16} />
      <span className="hidden sm:inline">Logout</span>
    </button>
  </div>
</header>
  );
};

export default Header;
